const roles = {
  ADMINISTRATOR: "Administrator",
  APPLICATION: "Application",
  SALES_MANAGER: "SalesManager",
} as const;

export default roles;

export type roleValues = typeof roles[keyof typeof roles];
